import { useEffect, useRef, useState } from 'react';

export default function StoryHeroSection() {
  const [scrollY, setScrollY] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/dd26c64e716bcb978eb07157fb139633.jpg')`,
          transform: `translateY(${scrollY * 0.4}px)`,
          willChange: 'transform',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div
        className="relative z-10 text-center px-6 max-w-4xl mx-auto transition-all duration-1000"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(40px)',
        }}
      >
        <div
          className="inline-block px-5 py-2 border border-white/40 rounded-full mb-8 text-white/80 text-sm tracking-widest"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 1s ease 0.2s',
          }}
        >
          OUR STORY
        </div>
        <h1
          className="text-7xl md:text-8xl font-bold text-white mb-8 leading-tight"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 1s ease 0.4s',
          }}
        >
          재봉틀 한 대에서
          <br />
          시작된 이야기
        </h1>
        <p
          className="text-xl text-white/90 leading-relaxed"
          style={{
            fontFamily: "'Noto Sans KR', sans-serif",
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 1s ease 0.6s',
          }}
        >
          기술은 사람을 자립하게 하고, 자립은 사람을 존중받게 합니다.
        </p>
      </div>

      <div
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2"
        style={{
          opacity: visible ? 1 : 0,
          transition: 'all 1s ease 1s',
        }}
      >
        <span className="text-white/60 text-xs tracking-widest">SCROLL</span>
        <div className="w-px h-12 bg-white/30 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full bg-white/80 animate-bounce" style={{ height: '40%' }}></div>
        </div>
      </div>
    </section>
  );
}
